import { render, staticRenderFns } from "./ViewStandardisedJobCard.vue?vue&type=template&id=7d8c78e6&scoped=true&"
import script from "./ViewStandardisedJobCard.vue?vue&type=script&lang=ts&"
export * from "./ViewStandardisedJobCard.vue?vue&type=script&lang=ts&"
import style0 from "./ViewStandardisedJobCard.vue?vue&type=style&index=0&id=7d8c78e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c78e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VIcon})
